<template>
  <div class="withdraw-funds-vue">
    <Header>
      <template v-slot:title>
        {{ $t("withdraw-funds-f08d90c08960cd320a338bb2571ff562") }}
      </template>
    </Header>
    <AlertNav
      :alert-message="$store.getters.get_alert_nav_message"
      v-if="$store.getters.get_alert_nav"
    />

    <div v-if="showSuspendedMessage" class="rounded-md bg-yellow-50 p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <svg
            aria-hidden="true"
            class="h-5 w-5 text-yellow-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              clip-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              fill-rule="evenodd"
            ></path>
          </svg>
        </div>
        <div class="ml-3">
          <h3
            class="text-sm font-normal text-yellow-800 withdraw-suspended-message"
          >
            <span
              v-if="this.whitelabel === 'ICMVC'"
              v-html="
                $t(
                  'your-account-is-currently-under-investigation-and-suspended-icmvc'
                )
              "
            ></span>
            <span
              v-if="this.whitelabel === 'ICMMU'"
              v-html="
                $t(
                  'your-account-is-currently-under-investigation-and-suspended-icmmu'
                )
              "
            ></span>
            <!-- #BR#52 - account investigation notice  - Mbeng  07/08/2025-->
            <span
              v-if="this.whitelabel === 'ICMSC'" 
              v-html="
                $t(
                  'your-account-is-currently-under-investigation-and-suspended-icmsc'
                )
              "
            ></span>
          </h3>
        </div>
      </div>
    </div>

    <!--            Modal for praxis methods-->
    <div v-if="response.hasData && showWithdrawModal" class="p-6">
      <div class="fixed z-10 inset-0 overflow-y-auto">
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
          ></span
          >&#8203;

          <div
            aria-labelledby="modal-headline"
            aria-modal="true"
            class="min-h-screen relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6"
            role="dialog"
          >
            <div
              class="absolute top-2 right-2"
              @click="(showWithdrawModal = false), (isDisabled = false)"
            >
              <button
                aria-label="Close panel"
                class="text-gray-400 hover:text-gray-500 transition ease-in-out duration-150"
              >
                <!-- Heroicon name: x -->
                <svg
                  class="h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 18L18 6M6 6l12 12"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                </svg>
              </button>
            </div>
            <div>
              <div class="mt-3 text-center sm:mt-5">
                <iframe
                  :src="response.url"
                  frameborder="0"
                  style="width: 100%; height: 50rem"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModal && !check_bank_account">
      <!-- This example requires Tailwind CSS v2.0+ -->
      <div class="fixed z-10 inset-0 overflow-y-auto">
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div aria-hidden="true" class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            aria-hidden="true"
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            >&#8203;</span
          >

          <div
            aria-labelledby="modal-headline"
            aria-modal="true"
            class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
            role="dialog"
          >
            <div>
              <div class="mt-3 text-center sm:mt-5">
                <h3
                  id="modal-headline"
                  class="text-lg leading-6 font-medium text-gray-900"
                >
                  {{ $t("add-bank-details") }}
                </h3>
                <div class="mt-2">
                  <p class="text-sm text-gray-500">
                    {{
                      $t(
                        "you-need-to-provide-your-bank-details-prior-to-requesting-a-withdrawal-through-withdrawalmethod"
                      ).replace("withdrawalMethod", form.method.name)
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
            >
              <button
                class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-1 sm:text-sm"
                type="button"
                @click="addBankDetails"
              >
                {{ $t("add-bank-details") }}
              </button>
              <button
                class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-2 sm:text-sm"
                type="button"
                @click="showModal = false"
              >
                {{ $t("Cancel") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div
        class="bg-white shadow rounded-md min-h-screen max-w-3xl m-auto p-8 sm:mt-5"
      >
        <div v-if="'state' in get_profile">
          <div
            v-if="get_profile.state === 'Limited'"
            class="rounded-md bg-yellow-50 sm:p-5 m-8"
          >
            <p>
              Your account is in limited state<span
                v-if="get_profile.profile.limits.withdrawals !== 0"
                >,</span
              >
            </p>
            <p v-if="get_profile.profile.limits.withdrawals !== 0">
              the Withdrawals are limited to
              {{ get_profile.profile.limits.withdrawals }}
              {{ get_profile.profile.reporting_currency }} total
            </p>
          </div>
        </div>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(requestWithdraw)">
            <div>
              <div>
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                  {{ $t("withdraw-funds-f08d90c08960cd320a338bb2571ff562") }}
                </h3>
                <p
                  v-if="
                    ($store.getters.get_profile.state === 'Full' ||
                      $store.getters.get_profile.state === 'Limited') &&
                    whitelabel !== 'ICMTrader' &&
                    whitelabel !== 'OrbitInvest'
                  "
                  class="my-3 text-sm leading-5 font-light text-gray-500"
                >
                  {{
                    $t(
                      "please-note-that-withdrawals-may-take-up-to-3-5-business-days"
                    )
                  }}
                </p>
                <p
                  v-if="
                    ($store.getters.get_profile.state === 'Full' ||
                      $store.getters.get_profile.state === 'Limited') &&
                    whitelabel !== 'ICMTrader'
                  "
                  class="my-3 text-sm leading-5 font-light text-gray-500"
                >
                  {{
                    $t(
                      "you-will-be-notified-via-email-when-your-request-is-processed"
                    )
                  }}
                </p>
              </div>
            </div>
             <!--#BR#23 - Mbeng Atemson 23/10/2024 -KYC verification message and whitelabel !== 'ICMMU' -->
             <!--#BR#73 - Mbeng Atemson 09/04/2025 -KYC verification message  and whitelabel !== 'ICMVC' -->
              <!--#BR#52 - Mbeng Atemson  -KYC verification message  and whitelabel !== 'ICMSC' 07/08/2025-->
             <complete-id-identification
              
              v-if="
                $store.getters.get_profile.state !== 'Full' &&
                $store.getters.get_profile.state !== 'Limited' &&
                (whitelabel === 'ICMMU' ||
                whitelabel === 'ICMSC' || 
                 whitelabel === 'ICMVC')
              "
              title="KYC verification is pending, please contact Support Team."
            ></complete-id-identification>
            <complete-id-identification
             
              v-if="
                $store.getters.get_profile.state !== 'Full' &&
                $store.getters.get_profile.state !== 'Limited' &&
                whitelabel !== 'ICMMU' &&
                whitelabel !== 'ICMSC' &&  
                whitelabel !== 'ICMVC'
              "
              title="before-you-are-able-to-withdraw-funds-you-must-complete-id-verification-process"
            ></complete-id-identification>

           
            <div v-else class="sm:border-t border-gray-200">
              <div class="flex flex-col">
                <div>
                  <div class="align-middle inline-block min-w-full">
                    <div>
                      <div class="mt-8 sm:mt-0 sm:border-gray-200 sm:py-5">
                        <dt class="text-sm mb-4 leading-5 font-normal">
                          {{
                            $t(
                              "please-select-the-trading-account-you-wish-to-withdraw-funds-from"
                            )
                          }}
                        </dt>
                        <need-trading-account-alert
                          v-if="$store.getters.get_live_accounts.length === 0"
                          :title="
                            $t(
                              'You-need-to-have-a-trading-account-in-order-to-withdraw-funds'
                            )
                          "
                        >
                        </need-trading-account-alert>
                        <dd
                          v-else
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0"
                        >
                          <div class="grid grid-cols-3 gap-4">
                            <button
                              v-for="(account, index) in account_data"
                              :id="account.id"
                              :key="index"
                              :class="
                                selectedAccount === account
                                  ? 'border-blue-500'
                                  : ''
                              "
                              class="relative text-left transition cursor-pointer p-3 pr-8 border rounded mr-3 w-full focus:outline-none"
                              type="reset"
                              @click="setAccount(account)"
                            >
                              <svg
                                v-if="account.backend.type === 'MT4'"
                                class="absolute top-2 right-2"
                                fill="none"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                              >
                                <rect fill="white" height="24" width="24" />
                                <rect
                                  fill="url(#pattern0)"
                                  height="16"
                                  width="16"
                                  x="4"
                                  y="4"
                                />
                                <defs>
                                  <pattern
                                    id="pattern0"
                                    height="1"
                                    patternContentUnits="objectBoundingBox"
                                    width="1"
                                  >
                                    <use
                                      transform="translate(-0.020202) scale(0.00505051)"
                                      xlink:href="#image0"
                                    />
                                  </pattern>
                                  <image
                                    id="image0"
                                    height="198"
                                    width="206"
                                    xlink:href="data:image/png;base64,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"
                                  />
                                </defs>
                              </svg>
                              <img
                                v-if="
                                  account.backend.type === 'DXTrade' &&
                                  whitelabel === 'EagleGlobalMarkets'
                                "
                                :src="
                                  require('../../assets/eagletrade-small.png')
                                "
                                alt="trading icon"
                                class="absolute top-2 right-2"
                                height="24"
                                width="24"
                              />
                              <span
                                v-if="
                                  (whitelabel === 'ICMEU' ||
                                    whitelabel === 'ICMVC' ||
                                    whitelabel === 'ICMSC' || // #BR#52 - icmsc - Mbeng 
                                    whitelabel === 'ICMCapital' ||
                                    whitelabel === 'ICMMENA' ||
                                    whitelabel === 'GCCBrokers' ||
                                    whitelabel === 'ICMAP' ||
                                    whitelabel === 'ICMMU' ||
                                    whitelabel === 'ICMEU' ||
                                    whitelabel === 'ICMTrader' ||
                                    whitelabel === 'TradiNext') &&
                                  account.backend.name.endsWith('IB')
                                "
                              >
                                Wallet - {{ account.external_id }}
                              </span>
                              <span
                                v-else-if="
                                  (whitelabel === 'TD365' ||
                                    whitelabel === 'TDSouthAfrica' ||
                                    whitelabel === 'Blackstone' ||
                                    whitelabel === 'EagleGlobalMarkets' ||
                                    whitelabel === 'TradeCoreUK') &&
                                  account.meta.Alphacode
                                "
                                class="word-break"
                              >
                                {{ checkBackendType(account.backend.type) }} -
                                {{ account.meta.Alphacode }}
                              </span>
                              <span
                                v-else-if="whitelabel === 'OrbitInvest'"
                                class="word-break"
                              >
                                {{ account.backend.display_name }}
                              </span>
                              <span
                                v-else-if="account.external_id"
                                class="word-break"
                              >
                                {{ checkBackendType(account.backend.type) }} -
                                {{ account.external_id }}
                              </span>
                              <span v-else class="word-break">
                                {{ checkBackendType(account.backend.type) }} -
                                Account not ready yet
                              </span>
                              <br />
                              <span
                                class="my-3 text-xs leading-5 font-light text-gray-400"
                              >
                                <span
                                  v-if="
                                    account.balance.WithdrawableAmount !== 'n/a'
                                  "
                                >
                                  {{
                                    new Intl.NumberFormat("en-US", {
                                      style: "currency",
                                      currency: account.currency,
                                    }).format(
                                      account.balance.WithdrawableAmount
                                    )
                                  }}
                                </span>
                                <span v-else>
                                  {{
                                    new Intl.NumberFormat("en-US", {
                                      style: "currency",
                                      currency: account.currency,
                                    }).format(0)
                                  }}
                                </span>
                              </span>
                            </button>
                          </div>
                        </dd>
                      </div>
                    </div>
                    <div
                      v-if="Object.keys(selectedAccount).length !== 0"
                      class="border-b border-gray-200"
                    >
                      <div
                        class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                      >
                        <dt class="text-sm leading-5 font-normal sm:col-span-3">
                          {{ $t("Equity") }}
                        </dt>
                        <dd
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                        >
                          <div class="sm:col-span-2">
                            <money-format
                              v-if="
                                selectedAccount.balance.TotalEquity !== 'n/a'
                              "
                              :currency-code="selectedAccount.currency"
                              :value="selectedAccount.balance.TotalEquity"
                            >
                            </money-format>
                            <span v-else> 0 </span>
                          </div>
                        </dd>
                      </div>
                    </div>
                    <!-- <div class="border-b border-gray-200" v-if="selectedAccount !== null">
                      <div class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5">
                        <dt class="text-sm leading-5 font-normal sm:col-span-3">
                          {{ $t('Free-margin') }}
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                          <div class="sm:col-span-2" v-if="selectedAccount.balance">
                            {{ selectedAccount.balance.Margin }}
                          </div>
                        </dd>
                      </div>
                    </div> -->
                    <div
                      v-if="Object.keys(selectedAccount).length !== 0"
                      class="border-b border-gray-200"
                    >
                      <div
                        class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                      >
                        <dt
                          v-if="
                            whitelabel === 'TDSouthAfrica' ||
                            whitelabel === 'EagleGlobalMarkets' ||
                            whitelabel === 'TradeCoreUK' ||
                            whitelabel === 'TD365'
                          "
                          class="text-sm leading-5 font-normal sm:col-span-3"
                        >
                          Unlocked balance
                        </dt>
                        <dt
                          v-else
                          class="text-sm leading-5 font-normal sm:col-span-3"
                        >
                          {{ $t("free-margin-available-balance") }}
                        </dt>
                        <dd
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                        >
                          <div class="sm:col-span-2">
                            <money-format
                              v-if="
                                selectedAccount.balance.CashBalance !== 'n/a'
                              "
                              :currency-code="selectedAccount.currency"
                              :value="selectedAccount.balance.CashBalance"
                            >
                            </money-format>
                            <span v-else> 0 </span>
                          </div>
                        </dd>
                      </div>
                    </div>
                    <div class="sm:border-b border-gray-200">
                      <div
                        class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                      >
                        <dt class="text-sm leading-5 font-normal sm:col-span-3">
                          {{ $t("enter-amount") }}
                        </dt>
                        <dd
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3"
                        >
                          <div class="sm:col-span-3">
                            <!-- Number field that will hold form.amount value
                               This field will be shown every time user types
                               and hidden every time he clicks away -->
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="`required|min_value:1|max_value:${maxAmount}`"
                              name="The minimum amount that can be withdrawn is 1."
                            >
                              <div
                                class="mt-1 relative rounded-md shadow-sm input"
                              >
                                <div
                                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                                >
                                  <span
                                    v-if="selectedAccount.currency"
                                    class="text-gray-300 sm:text-md sm:leading-5"
                                    v-html="
                                      new Intl.NumberFormat('en-US', {
                                        style: 'currency',
                                        currency: selectedAccount.currency,
                                      })
                                        .format()
                                        .slice(0, -3)
                                    "
                                  >
                                  </span>
                                </div>
                                <input
                                  id="amount"
                                  v-model="form.amount"
                                  :disabled="
                                    $store.getters.get_live_accounts.length ===
                                    0
                                  "
                                  aria-describedby="price-currency"
                                  class="form-input h-12 font-light block w-full pl-7 pr-3 sm:text-sm sm:leading-5"
                                  step="any"
                                  type="number"
                                />
                              </div>
                              <span class="text-sm text-red-600 h-4">{{
                                errors[0]
                              }}</span>
                              <span class="text-sm text-red-600 h-4">{{
                                error
                              }}</span>
                            </ValidationProvider>
                          </div>
                        </dd>
                      </div>
                    </div>
                    <div
                      v-if="
                        whitelabel !== 'TD365' &&
                        whitelabel !== 'TDSouthAfrica' &&
                        whitelabel !== 'Blackstone' &&
                        whitelabel !== 'EagleGlobalMarkets' &&
                        whitelabel !== 'TradeCoreUK'
                      "
                      class="sm:border-b border-gray-200"
                    >
                      <div
                        class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                      >
                        <dt
                          class="text-sm leading-5 font-normal sm:col-span-3 first-capitalize"
                        >
                          {{ $t("preferred-method") }}
                        </dt>
                        <dd
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3"
                        >
                          <div class="sm:col-span-1">
                            <ValidationProvider
                              v-slot="{ errors }"
                              name="currency"
                              rules="required"
                            >
                              <v-select
                                v-model="form.method"
                                :dir="
                                  checkLanguageDirection === 'rtl'
                                    ? 'rtl'
                                    : 'auto'
                                "
                                :disabled="
                                  $store.getters.get_live_accounts.length === 0
                                "
                                :options="get_withdrawal_methods"
                                :placeholder="
                                  $t(
                                    'select-an-option-59d5d61e9e9b2dc33a0211623cc4fe11'
                                  )
                                "
                                class="max-w-xs"
                                label="name_i18n"
                                @input="preferredMethodSelected"
                              ></v-select>
                              <span class="text-sm text-red-600 h-4">{{
                                errors[0]
                              }}</span>
                            </ValidationProvider>
                          </div>
                        </dd>
                      </div>
                    </div>

                    <div
                      v-if="
                        (whitelabel === 'OneTradingMarkets' ||
                          whitelabel === 'GCCBrokers') &&
                        BitPaceSelected
                      "
                      class="sm:border-b border-gray-200"
                    >
                      <div
                        class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                      >
                        <dt class="text-sm leading-5 font-normal sm:col-span-3">
                          Address
                        </dt>
                        <dd
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3"
                        >
                          <div class="sm:col-span-3">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="{ required: true }"
                            >
                              <div
                                class="mt-1 relative rounded-md shadow-sm input"
                              >
                                <input
                                  v-model="form.address"
                                  class="form-input h-12 font-light block w-full pl-7 pr-3 sm:text-sm sm:leading-5"
                                  label="address"
                                  placeholder="Address"
                                  step="any"
                                  type="text"
                                />
                              </div>
                              <span class="text-sm text-red-600 h-4">{{
                                errors[0]
                              }}</span>
                              <span class="text-sm text-red-600 h-4">{{
                                error
                              }}</span>
                            </ValidationProvider>
                          </div>
                        </dd>
                      </div>
                    </div>

                    <div
                      v-if="
                        (whitelabel === 'OneTradingMarkets' ||
                          whitelabel === 'GCCBrokers') &&
                        BitPaceSelected
                      "
                      class="sm:border-b border-gray-200"
                    >
                      <div
                        class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                      >
                        <dt
                          class="text-sm leading-5 font-normal sm:col-span-3 first-capitalize"
                        >
                          Currency
                        </dt>
                        <dd
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3"
                        >
                          <div class="sm:col-span-1">
                            <ValidationProvider
                              v-slot="{ errors }"
                              rules="required"
                            >
                              <v-select
                                v-model="form.currency"
                                :dir="
                                  checkLanguageDirection === 'rtl'
                                    ? 'rtl'
                                    : 'auto'
                                "
                                :options="get_currency_options"
                                :placeholder="
                                  $t(
                                    'select-an-option-59d5d61e9e9b2dc33a0211623cc4fe11'
                                  )
                                "
                                class="max-w-xs"
                                label="currency"
                              ></v-select>
                              <span class="text-sm text-red-600 h-4">{{
                                errors[0]
                              }}</span>
                            </ValidationProvider>
                          </div>
                        </dd>
                      </div>
                    </div>

                    <div
                      v-if="
                        (whitelabel === 'OneTradingMarkets' ||
                          whitelabel === 'GCCBrokers') &&
                        BitPaceSelected
                      "
                      class="sm:border-b border-gray-200"
                    >
                      <div
                        class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                      >
                        <dt class="text-sm leading-5 font-normal sm:col-span-3">
                          Destination tag
                        </dt>
                        <dd
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3"
                        >
                          <div class="sm:col-span-3">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="{ required: false }"
                            >
                              <div
                                class="mt-1 relative rounded-md shadow-sm input"
                              >
                                <input
                                  v-model="form.destination_tag"
                                  class="form-input h-12 font-light block w-full pl-7 pr-3 sm:text-sm sm:leading-5"
                                  label="destination_tag"
                                  placeholder="Destination tag"
                                  step="any"
                                  type="text"
                                />
                              </div>
                              <span class="text-sm text-red-600 h-4">{{
                                errors[0]
                              }}</span>
                              <span class="text-sm text-red-600 h-4">{{
                                error
                              }}</span>
                            </ValidationProvider>
                          </div>
                        </dd>
                      </div>
                    </div>

                    <div
                      v-if="
                        showCreditCard && whitelabel === 'OneTradingMarkets'
                      "
                      class="sm:border-b border-gray-200"
                    >
                      <div
                        class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                      >
                        <dt
                          class="text-sm leading-5 font-normal sm:col-span-3 first-capitalize"
                        >
                          <!-- {{ $t('card-number') }} -->
                          Card Number
                        </dt>
                        <dd
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3"
                        >
                          <div class="sm:col-span-1">
                            <ValidationProvider
                              v-slot="{ errors }"
                              rules="required"
                            >
                              <v-select
                                v-model="form.cardNumber"
                                :dir="
                                  checkLanguageDirection === 'rtl'
                                    ? 'rtl'
                                    : 'auto'
                                "
                                :options="get_available_cards"
                                :placeholder="
                                  $t(
                                    'select-an-option-59d5d61e9e9b2dc33a0211623cc4fe11'
                                  )
                                "
                                class="max-w-xs"
                                label="card_number"
                              ></v-select>
                              <span class="text-sm text-red-600 h-4">{{
                                errors[0]
                              }}</span>
                            </ValidationProvider>
                          </div>
                        </dd>
                      </div>
                    </div>

                    <div
                      v-if="
                        showCreditCard && whitelabel === 'OneTradingMarkets'
                      "
                      class="sm:border-b border-gray-200"
                    >
                      <div
                        class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                      >
                        <dt class="text-sm leading-5 font-normal sm:col-span-3">
                          <!-- {{ $t('card-expiration-date') }} -->
                          Card expiration date
                        </dt>
                        <dd
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3"
                        >
                          <div class="sm:col-span-3">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="{ required: true, cardNumber: true }"
                            >
                              <div
                                class="mt-1 relative rounded-md shadow-sm input"
                              >
                                <input
                                  id="cardDate"
                                  v-model="form.cardExpiration"
                                  aria-describedby="price-currency"
                                  class="form-input h-12 font-light block w-full pl-7 pr-3 sm:text-sm sm:leading-5"
                                  placeholder="MM/YY"
                                  step="any"
                                  type="text"
                                />
                              </div>
                              <span class="text-sm text-red-600 h-4">{{
                                errors[0]
                              }}</span>
                              <span class="text-sm text-red-600 h-4">{{
                                error
                              }}</span>
                            </ValidationProvider>
                          </div>
                        </dd>
                      </div>
                    </div>
                    <p
                      v-if="
                        showNoCreditCard && whitelabel === 'OneTradingMarkets'
                      "
                      class="mt-3"
                    >
                      This method is not available for you, please contact
                      support
                    </p>

                    <div
                      v-if="showWalletAddress"
                      class="sm:border-b border-gray-200"
                    >
                      <div
                        class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                      >
                        <dt class="text-sm leading-5 font-normal sm:col-span-3">
                          Enter wallet address
                        </dt>
                        <dd
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3"
                        >
                          <div class="sm:col-span-3">
                            <ValidationProvider
                              v-slot="{ errors }"
                              class=""
                              name="wallet_address"
                              rules="required"
                            >
                              <div class="">
                                <div class="mt-1 rounded-md shadow-sm">
                                  <input
                                    id="wallet_address"
                                    v-model="form.wallet_address"
                                    class="form-input h-12 font-light block w-full pl-7 pr-3 sm:text-sm sm:leading-5"
                                    placeholder="Enter wallet address"
                                    type="text"
                                  />
                                </div>
                                <span class="text-sm text-red-600 h-4">{{
                                  errors[0]
                                }}</span>
                              </div>
                            </ValidationProvider>
                          </div>
                        </dd>
                      </div>
                    </div>

                    <div
                      v-if="showUSDTwallet"
                      class="sm:border-b border-gray-200"
                    >
                      <div
                        class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:border-gray-200 sm:py-5"
                      >
                        <dt class="text-sm leading-5 font-normal sm:col-span-3">
                          USDT Wallet
                        </dt>
                        <dd
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3"
                        >
                          <div class="sm:col-span-3">
                            <ValidationProvider
                              v-slot="{ errors }"
                              class=""
                              name="usdt_wallet"
                              rules="required"
                            >
                              <div class="">
                                <div class="mt-1 rounded-md shadow-sm">
                                  <input
                                    id="usdt_wallet"
                                    v-model="form.usdt_wallet"
                                    class="form-input h-12 font-light block w-full pl-7 pr-3 sm:text-sm sm:leading-5"
                                    placeholder="Enter wallet address"
                                    type="text"
                                  />
                                </div>
                                <span class="text-sm text-red-600 h-4">{{
                                  errors[0]
                                }}</span>
                                <!-- Static network info #BR#109 - mbeng - message display for crypto method -->
                                <div v-if="!errors[0]" class="text-sm text-blue-600">
                                  {{$t('only-trc-20-erc-20-network-supported')}}
                                </div>
                              </div>
                            </ValidationProvider>
                          </div>
                        </dd>
                      </div>
                    </div>

                    <div
                      v-if="showBankAccount"
                      class="sm:border-b border-gray-200"
                    >
                      <div
                        class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:py-5"
                      >
                        <dt
                          class="text-sm leading-5 font-normal sm:col-span-2 capital-letter first-capitalize"
                        >
                          {{ $t("bank-account") }}
                        </dt>
                        <dd
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-4"
                        >
                          <div>
                            <ValidationProvider
                              v-slot="{ errors }"
                              name="currency"
                              rules="required"
                            >
                              <v-select
                                v-model="form.bank_account"
                                :disabled="
                                  $store.getters.get_live_accounts.length === 0
                                "
                                :options="bank_accounts"
                                :placeholder="
                                  $t(
                                    'select-an-option-59d5d61e9e9b2dc33a0211623cc4fe11'
                                  )
                                "
                                :reduce="(item) => item"
                                label="display_name"
                              ></v-select>
                              <span class="text-sm text-red-600 h-4">{{
                                errors[0]
                              }}</span>
                            </ValidationProvider>
                          </div>
                        </dd>
                      </div>
                    </div>
                    <div
                      v-if="
                        showBankAccount &&
                        form.bank_account &&
                        form.bank_account.id === -1
                      "
                      class="sm:border-b border-gray-200"
                    >
                      <div
                        class="mt-8 sm:mt-0 sm:grid sm:grid-cols-6 sm:gap-4 sm:py-5"
                      >
                        <dt
                          class="text-sm leading-5 font-normal sm:col-span-2 first-capitalize"
                        >
                          {{ $t("input-additional-information") }}
                        </dt>
                        <dd
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-4"
                        >
                          <div>
                            <ValidationProvider
                              v-slot="{ errors }"
                              class="row"
                              name="currency"
                              rules="required"
                            >
                              <textarea
                                id="additional_information"
                                v-model="form.additional_information"
                                class="p-2 max-w-lg shadow-sm border block w-full focus:outline-none sm:text-sm border-gray-300 rounded-md"
                                rows="5"
                              ></textarea>
                              <br />
                              <span class="text-sm text-red-600 h-4">{{
                                errors[0]
                              }}</span>
                            </ValidationProvider>
                          </div>
                        </dd>
                      </div>
                    </div>
                    <!-- #BR#52 - withdrawal fees consent to icmsc - Mbeng  -->
                    <div
                      v-if="whitelabel === 'ICMVC' || whitelabel === 'ICMMU' || whitelabel === 'ICMSC'"
                      class="sm:border-b border-gray-200"
                    >
                      <div class="mt-8 sm:mt-0 sm:border-gray-200 sm:py-5">
                        <dd class="mt-1 text-sm leading-5 text-gray-900">
                          <div class="sm:col-span-1">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="{ checkbox: true }"
                              name="consent"
                            >
                              <div class="relative flex items-start pt-6">
                                <div class="flex items-center h-5">
                                  <input
                                    id="consent"
                                    v-model="form.consent"
                                    class="form-checkbox h-4 w-4 transition duration-150 ease-in-out"
                                    required="true"
                                    type="checkbox"
                                  />
                                </div>
                                <div class="ml-3 text-sm leading-5 html-a">
                                  <label
                                    class="font-normal text-gray-700"
                                    for="consent"
                                    v-html="sanitizeText(icmWithdrawalFees)"
                                  >
                                  </label>
                                </div>
                              </div>
                              <span class="text-sm text-red-600 h-4">{{
                                errors[0]
                              }}</span>
                            </ValidationProvider>
                          </div>
                        </dd>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="py-6">
                <span class="inline-flex rounded-md shadow-sm w-full">
                  <Button
                    :disabled="
                      isDisabled ||
                      $store.getters.get_live_accounts.length === 0
                    "
                    class="relative block w-full bg-main-button-color items-center px-4 py-2 border border-transparent text-sm leading-5 font-normal rounded-md text-white focus:outline-none focus:shadow-outline-indigo"
                    type="submit"
                    @click="openOtpScreen"
                  >
                    {{ $t("request-withdrawal") }}
                  </Button>
                </span>
              </div>
            </div>
             <!-- #BR#98 Mbeng 9/06/2025 For ICMMU Tax details-->
             <!-- <complet-id-identification
             v-if="whitelabel==='ICMMU' && profileLoaded && showTaxAlert"><TaxDetailsAlert />
            </complet-id-identification> -->
            <div
              v-if="
                whitelabel === 'ICMCapital' ||
                whitelabel === 'ICMTrader' ||
                whitelabel === 'ICMMENA'
              "
              class="rounded-md mt-20"
            >
              <div class="flex">
                <div class="flex-shrink-0"></div>
                <div class="ml-3">
                  <h3
                    v-if="
                      whitelabel === 'ICMCapital' || whitelabel === 'ICMMENA'
                    "
                    class="text-sm leading-5 font-normal"
                  >
                    {{ $t("important-information") }}
                  </h3>
                  <h3
                    v-if="
                      $store.getters.get_profile.state === 'Full' &&
                      whitelabel === 'ICMTrader'
                    "
                    class="text-sm leading-5 font-normal"
                  >
                    {{ $t("important-information") }}
                  </h3>
                  <div class="mt-2 text-sm leading-5 text-gray-500">
                    <p
                      v-if="
                        whitelabel === 'ICMCapital' || whitelabel === 'ICMMENA'
                      "
                      style="white-space: pre-line"
                    >
                      {{
                        $t("as-per-standard-procedure-clients-must-withdraw")
                      }}
                    </p>
                    <p
                      v-if="
                        $store.getters.get_profile.state === 'Full' &&
                        whitelabel === 'ICMTrader'
                      "
                      class="my-3"
                      style="white-space: pre-line"
                    >
                      {{
                        $t(
                          "please-note-that-withdrawals-may-take-up-to-3-5-business-days"
                        )
                      }}
                    </p>
                    <p
                      v-if="
                        $store.getters.get_profile.state === 'Full' &&
                        whitelabel === 'ICMTrader'
                      "
                      class="my-3"
                      style="white-space: pre-line"
                    >
                      {{
                        $t(
                          "you-will-be-notified-via-email-when-your-request-is-processed"
                        )
                      }}
                    </p>
                    <p
                      v-if="
                        $store.getters.get_profile.state === 'Full' &&
                        whitelabel === 'ICMTrader'
                      "
                      class="my-3"
                      style="white-space: pre-line"
                    >
                      {{
                        $t(
                          "credit-card-debit-card-copies-may-be-required-to-verify-cards-for-deposits-and-withdrawals"
                        )
                      }}
                    </p>
                    <p
                      v-if="
                        $store.getters.get_profile.state === 'Full' &&
                        whitelabel === 'ICMTrader'
                      "
                      class="my-3"
                      style="white-space: pre-line"
                    >
                    <!-- EER#67 mbeng 18/08/2025 -->
                      {{
                        $t(
                          "ICM-Capital-Ltd-reserves-the-right-in-its-sole-discretion"
                        ).replace("ICM Capital Ltd", "ICM Trader LLC")
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
    <limited-state-upgrade-modal
      v-if="showLimitedStateUpgradeModalComputed"
      text="Your account is in Limited state and your Withdrawal limit has been exceeded."
      @close="closeModal"
    />
    <!-- BR#93 Sunny 08/08/2025 OTP validation on withdrawal request -->
    <OtpScreen 
      v-if="showOtpScreen" 
      :visible="showOtpScreen" 
      :otpToken="otpToken" 
      @otpVerified="requestWithdraw" 
      @close="showOtpScreen = false" 
    />
    <!-- BR#93 end -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Header from "@/components/Header";
import NeedTradingAccountAlert from "@/components/NeedTradingAccountAlert";
import CompleteIdIdentification from "@/components/CompleteIdIdentification";
import MoneyFormat from "vue-money-format";
import LimitedStateUpgradeModal from "@/views/LimitedStateUpgradeModal";
import AlertNav from "@/components/AlertNav.vue";
import TaxDetailsAlert from "@/components/TaxDetailsAlert"; //BR#98 Mbeng 9/06/2025 For ICMMU Tax details
import OtpScreen from "../../components/OtpScreen.vue"; //BR#93 Sunny 08/08/2025 OTP validation on withdrawal request

export default {
  name: "WithdrawFunds",
  components: {
    AlertNav,
    "money-format": MoneyFormat,
    Header,
    NeedTradingAccountAlert,
    CompleteIdIdentification,
    LimitedStateUpgradeModal,
    TaxDetailsAlert, //BR#98 Mbeng 9/06/2025 For ICMMU Tax details
    OtpScreen, //BR#93 Sunny 08/08/2025 OTP validation on withdrawal request
  },
  data() {
    return {
      showBankAccount: false,
      showWalletAddress: false,
      showUSDTwallet: false,
      form: {},
      selectedAccount: {},
      whitelabel: process.env.VUE_APP_WHITELABEL,
      error: null,
      maxAmount: Infinity,
      isDisabled: false,
      showModal: false,
      inputNumberVisible: true,
      inputNumberError: "",
      dotValue: 0,
      response: {
        hasData: false,
        url: "",
      },
      showWithdrawModal: false,
      actionName: "",
      languageDirection: "",
      showCreditCard: false,
      showNoCreditCard: false,
      BitPaceSelected: false,
      icmWithdrawalFees: "",
      showSuspendedMessage: false,
      showLimitedStateUpgradeModal: false,
      showLimitedUserMessage: false,

      showTaxAlert: false,
      profileLoaded: false,
      showOtpScreen: false //BR#93 Sunny 08/08/2025 OTP validation on withdrawal request


    };
  },
  computed: {
    ...mapGetters(["get_profile", "get_uploaded_documents"]),
    get_withdrawal_methods() {
      const t = this.$t.bind(this);

      const methods = this.$store.getters.get_withdrawal_methods.map((item) => {
        if (
          item.name === "Credit Card" &&
          (process.env.VUE_APP_WHITELABEL === "ICMVC" ||
            process.env.VUE_APP_WHITELABEL === "ICMSC" ||  // #BR#52 - enable credit card icmsc - Mbeng 
            process.env.VUE_APP_WHITELABEL === "ICMMU" ||
            process.env.VUE_APP_WHITELABEL === "ICMCapital" ||
            process.env.VUE_APP_WHITELABEL === "ICMMENA" ||
            process.env.VUE_APP_WHITELABEL === "GCCBrokers" ||
            process.env.VUE_APP_WHITELABEL === "TradiNext")
        ) {
          item.name_i18n = t("credit-debit-card");
          return item;
        } else if (
          item.name === "PraxisPay" &&
          process.env.VUE_APP_WHITELABEL === "GCCBrokers"
        ) {
          item.name_i18n = "GCC Brokers Cashier";
          return item;
        }
        return item;
      });

      if (this.whitelabel === "VCGMarkets") {
        return methods.filter((item) => item?.gateways.length > 0);
      }
      return methods;
    },
    bank_accounts() {
      const accounts = this.$store.getters.get_bank_accounts.map((item) => {
        return {
          ...item,
          display_name:
            item.account_holdername + ", " + item.bank_account_number,
        };
      });
      if (
        [
          "ICMCapital",
          "ICMMENA",
          "GCCBrokers",
          "TradiNext",
          "ICMVC",
          "ICMSC", // #BR#52  - Mbeng 
          "ICMEU",
          "ICMAP",
          "ICMMU",
          "ICMTrader",
        ].includes(this.whitelabel) &&
        this.showModal
      ) {
        return accounts.concat({
          display_name: "Other Account Type",
          id: -1,
        });
      } else {
        return accounts;
      }
    },
    check_bank_account() {
      return this.$store.getters.get_bank_accounts.length !== 0;
    },
    account_data() {
      return this.$store.getters.get_account_data.filter(
        (account) => account.backend.mode === "Live"
      );
    },
    // on select forms, we need to set dir = 'rtl' instead of default dir='auto'
    // so non translated text would show the corect way on arab and persian pages
    checkLanguageDirection() {
      this.languageDirection = this.$store.getters.get_lang;
      if (this.lang === "ar" || this.lang === "fa") {
        return document.getElementById("body").dir;
      } else {
        return document.getElementById("body").dir;
      }
    },
    get_available_cards() {
      return this.$store.getters.get_available_cards.map((item) => {
        return item;
      });
    },
    get_currency_options() {
      return [
        "ALGO",
        "AVAX",
        "BCH",
        "BTC",
        "DOT",
        "EOS",
        "ETH",
        "LINK",
        "LTC",
        "TRX",
        "USDC",
        "USDT",
        "XLM",
        "XRP",
      ];
    },
    showLimitedStateUpgradeModalComputed() {
      return (this.showLimitedStateUpgradeModal =
        this.$store.getters.get_limited_state_upgrade_modal);
    },
  },
  mounted() {
    this.$store.dispatch("withdrawal_methods");
    this.$store.dispatch("bank_accounts");
    this.$store.dispatch("account_data").then((resp) => {
      let accounts = resp.data.filter(
        (account) => account.backend.mode === "Live"
      );
      if (accounts.length > 0) {
        this.selectedAccount = accounts[0];
        this.maxAmount = this.selectedAccount.balance.WithdrawableAmount;
      }
    });
    if (this.whitelabel === "ICMVC") {
      if (
        this.get_profile.address.addr_country === "Malaysia" ||
        this.get_profile.address.addr_country === "Vietnam" ||
        this.get_profile.address.addr_country === "Indonesia" ||
        this.get_profile.address.addr_country === "Thailand" ||
        this.get_profile.address.addr_country === "India"
      ) {
        this.icmWithdrawalFees = this.$t(
          "i-agree-that-icm-will-deduct-the-withdrawal-fee-from-the-requested-withdrawal-amount-icmvc-asia"
        );
      } else {
        this.icmWithdrawalFees = this.$t(
          "i-agree-that-icm-will-deduct-the-withdrawal-fee-from-the-requested-withdrawal-amount-icmvc"
        );
      }
    } else if (this.whitelabel === "ICMMU") {
      if (
        this.get_profile.address.addr_country === "Malaysia" ||
        this.get_profile.address.addr_country === "Vietnam" ||
        this.get_profile.address.addr_country === "Indonesia" ||
        this.get_profile.address.addr_country === "Thailand" ||
        this.get_profile.address.addr_country === "India"
      ) {
        this.icmWithdrawalFees = this.$t(
          "i-agree-that-icm-will-deduct-the-withdrawal-fee-from-the-requested-withdrawal-amount-icmmu-asia"
        );
      } else {
        this.icmWithdrawalFees = this.$t(
          "i-agree-that-icm-will-deduct-the-withdrawal-fee-from-the-requested-withdrawal-amount-icmmu"
        );
      }
      // #BR#52 - apply withdrawal fees to icmsc - Mbeng 
    } else if (this.whitelabel === "ICMSC") {
      if (
        this.get_profile.address.addr_country === "Malaysia" ||
        this.get_profile.address.addr_country === "Vietnam" ||
        this.get_profile.address.addr_country === "Indonesia" ||
        this.get_profile.address.addr_country === "Thailand" ||
        this.get_profile.address.addr_country === "India"
      ) {
        this.icmWithdrawalFees = this.$t(
          "i-agree-that-icm-will-deduct-the-withdrawal-fee-from-the-requested-withdrawal-amount-icmsc-asia"
        );
      } else {
        this.icmWithdrawalFees = this.$t(
          "i-agree-that-icm-will-deduct-the-withdrawal-fee-from-the-requested-withdrawal-amount-icmsc"
        );
      }
    }
    // #BR#52 - added icmsc to is able to withdraw function - Mbeng 
    if (this.whitelabel === "ICMVC" || this.whitelabel === "ICMMU" || this.whitelabel === "ICMSC") {
      if ("is_able_to_withdraw" in this.get_profile.profile) {
        if (this.get_profile.profile.is_able_to_withdraw === false) {
          this.showSuspendedMessage = true;
          this.isDisabled = true;
        } else {
          this.showSuspendedMessage = false;
          this.isDisabled = false;
        }
      }
    }
  },
  methods: {
        // BR#93 Sunny 08/08/2025 OTP validation on withdrawal request
    openOtpScreen(res) {

    const userId = this.get_profile.id;
    const whitelabel = this.get_profile.whitelabel;
    const paymentGateway = this.form.method.name;
    const language = this._i18n.i18next.language;
    const hasConsent = this.form?.consent
    localStorage.setItem("user_id", userId)

    const otpGateways = ["Finrax", "Coinspaid", "LetKnowBinancePay", "LetKnowCrypto"];
    const usdtWalletGateways = ["Finrax", "Coinspaid", "LetKnowBinancePay","LetKnowCrypto"];
    const isWhitelabelAllowed = ["ICMMU", "ICMVC"].includes(whitelabel);

    const hasAmount =
      this.form?.amount !== undefined &&
      this.form?.amount !== null &&
      this.form?.amount !== "" &&
      this.form?.amount !== "undefined";

    const hasUsdtWalletValue =
      this.form?.usdt_wallet !== undefined &&
      this.form?.usdt_wallet !== null &&
      this.form?.usdt_wallet !== "" &&
      this.form?.usdt_wallet !== "undefined";


    if (otpGateways.includes(paymentGateway) && isWhitelabelAllowed && hasAmount && hasConsent) {
      if (usdtWalletGateways.includes(paymentGateway) && !hasUsdtWalletValue) {
        return;
      }
      if (event && typeof event.preventDefault === "function") event.preventDefault();
      this.$store.dispatch("triggerOtp", { userId, language });
      this.showOtpScreen = true;
    } 
  },
  // BR#93 end
    checkBackendType(type) {
      // EGM wanted to rename DXTrade to Eagletrade
      // if(type === 'DXTrade'){
      //   return 'Eagletrade'
      // } else {
      //   return type
      // }
      return type;
    },
    requestWithdraw() {
      this.showOtpScreen = false; //BR#93 Sunny 08/08/2025 OTP validation on withdrawal request
      this.isDisabled = true;
      let data = {
        amount: this.form.amount,
        meta: {},
        trading_account: this.selectedAccount.id,
      };
      if (
        this.whitelabel !== "TD365" &&
        this.whitelabel !== "TDSouthAfrica" &&
        this.whitelabel !== "Blackstone" &&
        this.whitelabel !== "EagleGlobalMarkets" &&
        this.whitelabel !== "TradeCoreUK"
      ) {
        data.method = this.form.method.id;
      }
      // if (this.form.method.gateways.includes('praxispay')) {
      //   this.showWithdrawModal = true
      //   data.return_url = location.href + '?get=1'
      //   data.gateway = 'praxispay'
      //   this.$store.dispatch('withdraw_praxispay', data).then(resp => {
      //     this.response.hasData = true
      //     this.response.url = resp.data.url
      //   }).catch(err => {
      //     this.isDisabled = false
      //     this.$notify({
      //       group: 'foo',
      //       text: `${Object.values(err.data)[0]}`,
      //       type: 'warn'
      //     });
      //   })
      // }
      // else {
      if (this.form.wallet_address) {
        data.address = this.form.wallet_address;
      }
      if (this.form.usdt_wallet) {
        data.address = this.form.usdt_wallet;
      }
      if (this.form.additional_information) {
        data.additional_information = this.form.additional_information;
      }
      if (
        this.form.bank_account &&
        this.form.bank_account.display_name !== "Other Account Type"
      ) {
        data.payment_gateway_account = this.form.bank_account.id;
        delete data.additional_information;
      }
      if (!this.form.bank_account) {
        if (data.additional_information) {
          delete data.additional_information;
        }
        if (data.payment_gateway_accountn) {
          delete data.payment_gateway_account;
        }
      }
      if (
        this.whitelabel === "TD365" ||
        this.whitelabel === "TDSouthAfrica" ||
        this.whitelabel === "Blackstone" ||
        this.whitelabel === "EagleGlobalMarkets" ||
        this.whitelabel === "TradeCoreUK" ||
        this.whitelabel === "OneTradingMarkets"
      ) {
        this.actionName = "withdraw_request_td365";
      } else {
        this.actionName = "withdraw";
      }
      if (
        this.whitelabel === "OneTradingMarkets" &&
        this.form.method.gateways.includes("gatetopay")
      ) {
        data.meta.card_id = this.form.cardNumber.card_id;
        data.meta.card_number = this.form.cardNumber.card_number;
        data.meta.card_expiry = this.form.cardExpiration;
      }

      if (
        (this.whitelabel === "OneTradingMarkets" ||
          this.whitelabel === "GCCBrokers") &&
        this.form.method.gateways.includes("bitpace")
      ) {
        data.meta.address = this.form.address;
        data.meta.currency = this.form.currency;
        if (this.form.destination_tag) {
          data.meta.destination_tag = this.form.destination_tag;
        }
      }

      this.$store
        .dispatch(this.actionName, data)
        .then((resp) => {
          //this function is here so we can reset trading accounts
          // and show the new available balance after the withdrawal request
          this.$store.dispatch("account_data").then((resp) => {
            let accounts = resp.data.filter(
              (account) => account.backend.mode === "Live"
            );
            if (accounts.length > 0) {
              // we are setting accounts[index] of trading account that was already selected
              // at the time of the withdrawal request so he will remain selected
              this.selectedAccount =
                accounts[
                  accounts.findIndex((x) => x.id === this.selectedAccount.id)
                ];
              this.maxAmount = this.selectedAccount.balance.WithdrawableAmount;
            }
          });
          this.isDisabled = false;
         // # BR#54 Sunny 30/09/2026 Automating the withdrawal process
          if (resp.data && resp.data.url && 
              (resp.data.email === "it.testing@icm.com" || 
              resp.data.email === "psp@icm.com")) {
            this.response.hasData = true;
             this.showWithdrawModal = true;
             this.response.url = resp.data.url;
           } else {
             this.$notify({
               group: "foo",
               text: this.$t(
                 "your-withdrawal-request-has-been-received-and-is-pending-approval"
               ),})}
          //  this.response.hasData = true    //BR#54
          //  this.showWithdrawModal = true;    //BR#54
          //  this.response.url = resp.data.url;    //BR#54
           })
          // BR#54 end 
          // # BR#54 Sunny 16/10/2025 revert
          //this.isDisabled = false;
          //this.$notify({
           //group: "foo",
           //text: `${this.$t(
             //"your-withdrawal-request-has-been-received-and-is-pending-approval"
           //)}`,
         //});
        //})
        // BR#54 end 
        .catch((err) => {
          if ("state" in this.get_profile) {
            if (this.get_profile.state === "Limited" && err.status === 422) {
              this.$store.commit("SET_LIMITED_USER_MESSAGE", true);
              this.$store.commit("SET_LIMITED_STATE_UPGRADE_MODAL", true);
              this.isDisabled = false;
              return;
            }
          }
          this.isDisabled = false;
          this.$notify({
            group: "foo",
            text: `${Object.values(err.data)[0]}`,
            type: "warn",
          });
        });

      // }
    },
    setAccount(account) {
      this.selectedAccount = account;
      this.maxAmount = this.selectedAccount.balance.WithdrawableAmount;
    },
    //BR#45 - mbeng atemson - 03/01/2025 - enabled additional information field and bank account detail mandatory
    //for Help2Pay, Walaopay, DINPay,FXPay - ICMMU 
    preferredMethodSelected() {
      if (this.form.method.name !== "Bank" &&
          this.form.method.name !== "Help2Pay"  &&
          this.form.method.name !== "ICMCapitalMU-Walaopay" &&
          this.form.method.name !== "DinPay" &&
          this.form.method.name !== "FXPay"
      ) {
        if (this.form.additional_information) {
          delete this.form.additional_information;
        }
        if (this.form.bank_account) {
          delete this.form.bank_account;
        }
      }
      if (
        //BR#45 - mbeng atemson - 03/01/2025 - enabled additional information field and bank account detail mandatory
        //for Help2Pay, Walaopay, DINPay,FXPay - ICMMU 
        this.form.method.name === "Bank" ||
        this.form.method.name === "PayTrust" ||
        (this.form.method.name === "Help2Pay" && this.whitelabel === "ICMMU") ||
        (this.form.method.name === "ICMCapitalMU-Walaopay" && this.whitelabel === "ICMMU")||
        (this.form.method.name === "DinPay" && this.whitelabel === "ICMMU") ||
        (this.form.method.name === "FXPay" && this.whitelabel === "ICMMU")
      ) {
        this.showModal = true;
        this.showBankAccount = true;
      } else {
        this.showBankAccount = false;
      }
      if (this.form.method.gateways.includes("b2binpay")) {
        this.showWalletAddress = true;
      } else {
        this.showWalletAddress = false;
        if (this.form.wallet_address) {
          delete this.form.wallet_address;
        }
      }
      // if (
      //   (this.whitelabel === "ICMVC" || this.whitelabel === "ICMMU") &&
      //   (this.form.method.name === "Finrax" ||
      //     this.form.method.name === "Coinspaid")
      // ) {
      //   this.showUSDTwallet = true;
      // } else {
      //   this.showUSDTwallet = false;
      //   if (this.form.usdt_wallet) {
      //     delete this.form.usdt_wallet;
      //   } 
      
      //#BR#55 (LetKnowBinancePay)- #BR#6 - Mbeng Atemson - added LetKnowBinancePay and showusdtwallet - #BR#52 -#BR#125 (LetKnowCrypto)
       if (
            (this.whitelabel === "ICMVC" || this.whitelabel === "ICMMU" || this.whitelabel === "ICMSC") &&
              (this.form.method.name === "Finrax" ||
              this.form.method.name === "Coinspaid" || 
              this.form.method.name === "LetKnowBinancePay" ||
              this.form.method.name === "LetKnowCrypto" ||
              this.form.method.name === "Crypto")
          ) {
            this.showUSDTwallet = true;
         } //else if(this.whitelabel === "ICMMU"  &&  this.form.method.name === "LetKnowBinancePay")
        // {
        //       this.showUSDTwallet = true;
        // }
            else {
            this.showUSDTwallet = false;
            if (this.form.usdt_wallet) {
              delete this.form.usdt_wallet;
          }


      // if (
      //   this.whitelabel === "ICMMU"  && 
      //   (this.form.method.name === "LetKnowBinancePay" || this.form.method.name === "Finrax" || this.form.method.name === "Coinspaid" )
      // ) {
      //   this.showUSDTwallet = true;
      // } else {
      //   this.showUSDTwallet = false;
      //   if (this.form.usdt_wallet) {
      //     delete this.form.usdt_wallet;
      //   }
       }
      if (
        this.whitelabel === "OneTradingMarkets" &&
        this.form.method.gateways.includes("gatetopay")
      ) {
        this.$store
          .dispatch("available_cards", this.selectedAccount.id)
          .then(() => {
            // if user does not have any credit card numbers on his account
            if (this.$store.getters.get_available_cards.length > 0) {
              this.showCreditCard = true;
              this.isDisabled = false;
            } else {
              this.showNoCreditCard = true;
              this.isDisabled = true;
            }
          });
      } else {
        this.showCreditCard = false;
        this.showNoCreditCard = false;
        if (this.showSuspendedMessage === false) {
          this.isDisabled = false;
        }
      }
      if (
        (this.whitelabel === "OneTradingMarkets" ||
          this.whitelabel === "GCCBrokers") &&
        this.form.method.gateways.includes("bitpace")
      ) {
        this.BitPaceSelected = true;
      } else {
        this.BitPaceSelected = false;
      }
    },
    addBankDetails() {
      this.$router.push("/bank-details");
      this.$store.commit("SHOW_ADD_BANK_ACCOUNT", true);
    },
    sanitizeText(text) {
      return this.$sanitize(
        text
          .replace("%first_name%", this.get_profile.first_name)
          .replace("%last_name%", this.get_profile.last_name)
          .replace("{first_name}", this.get_profile.first_name)
          .replace("{last_name}", this.get_profile.last_name)
          .replace("{company_name}", this.get_profile.company_name)
          .replace("%company_name%", this.get_profile.company_name)
      );
    },
    closeModal() {
      this.showLimitedStateUpgradeModal = false;
      this.showLimitedUserMessage = false;
    },
  // BR#98 
    checkTaxAlert(profile) {
      const nicFields = profile?.nic_fields || [];
      const requiredPriorities = [3, 4, 5, 6];
      const hasMissingTIN = requiredPriorities.some((priority) => {
        const field = nicFields.find((n) => n.priority === priority);
        return !field || !field.value;
      });
      this.showTaxAlert = hasMissingTIN;
      this.profileLoaded = true;
    }
  },

  watch: {
  get_profile: {
    handler(profile) {
      if (profile && profile.nic_fields) {
        this.checkTaxAlert(profile);
      }
    },
    immediate: true,
    deep: true,
  }
}
};
</script>
<style>
.first-capitalize::first-letter {
  text-transform: uppercase;
}

.first-capitalize {
  text-transform: lowercase;
}
</style>
